import { render, staticRenderFns } from "./BlogHome.vue?vue&type=template&id=21d86a2a&scoped=true&"
import script from "./BlogHome.vue?vue&type=script&lang=js&"
export * from "./BlogHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d86a2a",
  null
  
)

export default component.exports